import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Container, Drawer, IconButton, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import EventRegistrationFormSummary from '@ui/pages/EventRegistration/RegistrationForm/components/EventRegistrationFormSummary';
import { useEventRegistrationTranslation } from './hooks/useEventRegistrationTranslation';
import { eventRegistrationDrawerCloseButtonSx, eventRegistrationDrawerSlideProps, getEventRegistrationDrawerContentHeight, getEventRegistrationDrawerPaperProps } from './eventRegistrationDrawerStyles';
import EmbeddedPreviewSheet from './EmbeddedPreviewSheet';
import { useEventRegistrationDrawerContext } from './EventRegistrationDrawerContext';
const EventRegistrationSummaryDrawer = ({ embeddedPreview = false, previewLayout }) => {
    const { t } = useEventRegistrationTranslation();
    const { summaryOpen, closeSummary, summarySteps } = useEventRegistrationDrawerContext();
    const content = (_jsxs(_Fragment, { children: [_jsxs(Box, { sx: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    px: { xs: 2, sm: 1 },
                    pt: { xs: 2, sm: 1 },
                    pb: 1,
                    gap: 1
                }, children: [_jsx(Typography, { variant: 'subtitle1', color: '#00244D', sx: { fontWeight: 600, textTransform: 'uppercase' }, children: t('eventRegistration.form.summaryTitle', { defaultValue: 'Summary' }) }), _jsx(IconButton, { onClick: closeSummary, "aria-label": t('actions.close'), sx: eventRegistrationDrawerCloseButtonSx, children: _jsx(Icon, { icon: 'mdi:close', fontSize: 16 }) })] }), _jsx(Container, { sx: {
                    height: getEventRegistrationDrawerContentHeight(embeddedPreview),
                    mb: '8px',
                    overflow: 'hidden',
                    px: { xs: 2, sm: 3 },
                    pb: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0
                }, children: _jsx(EventRegistrationFormSummary, { steps: summarySteps, panelSx: { flex: 1, minHeight: 0, borderRadius: 2 }, imageWrapSx: { px: { xs: 1.25, sm: 2 }, pt: { xs: 1.25, sm: 2 } }, contentSx: {
                        flex: 1,
                        minHeight: 0,
                        overflowY: 'auto',
                        px: { xs: 1.25, sm: 2 },
                        pb: { xs: 1.5, sm: 2 },
                        pt: 1
                    } }) })] }));
    if (embeddedPreview) {
        return (_jsx(EmbeddedPreviewSheet, { open: summaryOpen, onClose: closeSummary, previewLayout: previewLayout, children: content }));
    }
    return (_jsx(Drawer, { anchor: 'right', open: summaryOpen, onClose: closeSummary, SlideProps: eventRegistrationDrawerSlideProps, PaperProps: getEventRegistrationDrawerPaperProps(false), children: content }));
};
export default EventRegistrationSummaryDrawer;
